// import React, { useEffect, useState } from "react";
// import api from "../../../../../api/axios";
// import DataTable from "../../../../../Common/DataTable/DataTable";
// import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
// import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
// import { bookingColumns } from "./BookingTableData";
// import { Link } from "react-router-dom";

// const BookingTable = () => {
//   const [tableData, setTableData] = useState([]);
//   const [roomTypes, setRoomTypes] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   loadRoomTypes();
//   // }, []);

//   useEffect(() => {
//     // if (roomTypes.length > 0) {
//     loadReservations();
//     // }
//   }, []);

//   // const loadRoomTypes = async () => {
//   //   try {
//   //     const res = await api.get("/pms/room-type");
//   //     setRoomTypes(res.data?.data || []);
//   //   } catch (err) {
//   //     console.error("Failed to load room types:", err);
//   //   }
//   // };

//   // Load reservations and their payments
//   const loadReservations = async () => {
//     try {
//       setLoading(true);

//       const res = await api.get("/pms/reservations");
//       const reservations = res.data?.data || [];

//       const finalData = await Promise.all(
//         reservations.map(async (r) => {
//           const payRes = await api.get(`/pms/reservations/${r.id}/payments`);
//           const payments = payRes.data?.data || [];

//           const paidAmount = payments.reduce(
//             (sum, p) => sum + Number(p.amount || 0),
//             0
//           );

//           const dueAmount = (Number(r.total) || 0) - paidAmount;

//           // Find room type name
//           // const roomTypeName =
//           //   roomTypes.find((t) => t.id == r.room?.room_type_id)?.name || "-";

//           return {
//             name: r.guest?.name || "-",
//             number: r.room?.room_number || "-",
//             roomType: r.room?.type || "-",
//             checkIn: r.check_in?.substring(0, 10),
//             checkOut: r.check_out?.substring(0, 10),
//             paidAmount: paidAmount.toFixed(2),
//             dueAmount: dueAmount.toFixed(2),
//             action:
//               r.status === "reserved" ? (
//                 <Link
//                   to={`/reservation/${r.id}/check-in`}
//                   className="btn btn-sm btn-primary"
//                 >
//                   Check In
//                 </Link>
//               ) : (
//                 <span className="text-muted">{r.status}</span> // optional placeholder
//               ),
//             paymentStatus: (
//               <span
//                 className={`badge ${
//                   dueAmount <= 0 ? "text-bg-success" : "text-bg-warning"
//                 }`}
//               >
//                 {dueAmount <= 0 ? "Paid" : "Pending"}
//               </span>
//             ),
//           };
//         })
//       );

//       setTableData(finalData);
//     } catch (err) {
//       console.error("Error loading reservations:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div
//         className="d-flex justify-content-center align-items-center"
//         style={{ height: "60vh" }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <DataTableHeader />
//       <DataTable columns={bookingColumns} data={tableData} loading={loading} />
//       <DataTableFooter dataT={tableData} />
//     </>
//   );
// };

// export default BookingTable;

import React, { useEffect, useState } from "react";
import api from "../../../../../api/axios";
import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { bookingColumns } from "./BookingTableData";
import { Link } from "react-router-dom";

const BookingTable = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const statusLabelMap = {
    reserved: "Reserved",
    checked_in: "Check In",
    checked_out: "Check Out",
  };

  const statusColorMap = {
    reserved: "warning",
    checked_in: "success",
    checked_out: "secondary",
  };

  useEffect(() => {
    loadReservations();
  }, []);

  const loadReservations = async () => {
    try {
      setLoading(true);

      // NEW: call backend API that returns precomputed paid_amount / due_amount / pos items etc.
      // Make sure backend route matches this: GET /pms/reservations-payment
      const res = await api.get("/pms/bookinglist");
      const reservations = res.data || [];

      // Map backend response directly to table rows (no calculations here)
      const finalData = reservations.map((r) => {
        return {
          id: r.id, // keep id for actions
          name: r.guestName || r.guest?.name || "-",
          number: r.roomNumber || r.room?.room_number || "-",
          roomType: r.roomType || r.room?.type || "-",
          checkIn:
            r.checkIn ||
            (r.checkIn && r.checkIn.substring
              ? r.checkIn.substring(0, 10)
              : r.checkIn),
          checkOut:
            r.checkOut ||
            (r.checkOut && r.checkOut.substring
              ? r.checkOut.substring(0, 10)
              : r.checkOut),
          paidAmount:
            typeof r.paidAmount !== "undefined" && r.paidAmount !== null
              ? Number(r.paidAmount).toFixed(2)
              : "0.00",
          dueAmount:
            typeof r.dueAmount !== "undefined" && r.dueAmount !== null
              ? Number(r.dueAmount).toFixed(2)
              : "0.00",
          paymentStatus:
            typeof r.dueAmount !== "undefined" && Number(r.dueAmount) <= 0 ? (
              <span className="badge text-bg-success">Paid</span>
            ) : (
              <span className="badge text-bg-warning">Pending</span>
            ),
          action:
            r.status === "reserved" ? (
              <Link
                to={`/reservation/${r.id}/check-in`}
                className="btn btn-sm btn-primary rounded-pill px-4 text-nowrap"
              >
                Check In
              </Link>
            ) : (
              <span
                className={`badge rounded-pill bg-${statusColorMap[r.status]}`}
              >
                {statusLabelMap[r.status]}
              </span>
            ),
          // Keep whole reservation object handy if needed later (preview)
          __raw: r,
        };
      });

      setTableData(finalData);
    } catch (err) {
      console.error(
        "Error loading reservations from /pms/reservations-payment:",
        err
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <DataTableHeader />
      <DataTable columns={bookingColumns} data={tableData} loading={loading} />
      {/* <DataTableFooter dataT={tableData} /> */}
    </>
  );
};

export default BookingTable;
